import { atom, useAtom } from 'jotai';
import { useIsBelowBreakpoint } from '@teetsh/app/src/components/ResponsiveSwitcher/useIsBelowSize';
import { useEffect, useRef } from 'react';

const isSidebarOpenAtom = atom<boolean | null>(null);

export function useSidebarStatus() {
  const isMobileOrTablette = useIsBelowBreakpoint('lg');
  const [isOpen, setIsOpen] = useAtom(isSidebarOpenAtom);
  const prevIsMobile = useRef(isMobileOrTablette);

  // If the user resizes the window to a tablet size, we close the sidebar
  useEffect(() => {
    if (!prevIsMobile.current && isMobileOrTablette) {
      setIsOpen(false);
    }

    prevIsMobile.current = isMobileOrTablette;
  }, [isMobileOrTablette, setIsOpen]);

  return {
    isOpen: isOpen === null ? !isMobileOrTablette : isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    toggle: () => setIsOpen(isOpen === null ? isMobileOrTablette : !isOpen),
  };
}
